import { Button, QuickGlanceActions, QuickGlanceOverlay, DataBlock } from '@fs/zion-ui'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { getPersonAge, getPersonRelationships, useSlsStateContext } from '@fs/zion-sls'

const InfoOverlay = ({ person, overlayProps }) => {
  const { images } = useSlsStateContext()
  const [t] = useTranslation()
  const relations = useMemo(() => getPersonRelationships(person, images), [person, images])
  const age = useMemo(() => getPersonAge(person), [person])

  return (
    <QuickGlanceOverlay
      {...overlayProps}
      footer={
        <QuickGlanceActions>
          <Button onClick={overlayProps.close} emphasis="high" dense linkName="Close Person Quick Info Overlay">
            {t('navigation.done-button', 'Done')}
          </Button>
        </QuickGlanceActions>
      }
      title={person.fullName}
      placement={['bottom-end', 'top-end']}
    >
      <div style={{ minWidth: '18rem' }}>
        <DataBlock heading={t('view-index.age.title', 'Age')} data={age} />
        <br />
        <DataBlock
          heading={t('view-index.relationships.title', 'Relationships')}
          data={
            relations?.length > 0 &&
            relations?.map((relation) => (
              <>
                {`${relation?.value} (${relation?.label})`} <br />
              </>
            ))
          }
        />
      </div>
      <br />
    </QuickGlanceOverlay>
  )
}

export default InfoOverlay
